<template>
    <div class="page homesalecalc" v-ga:request="{pageType:'vhomesalecalc', state: {}}" v-ga:page="{pageType:'vhomesalecalc', glb: glb, state: {}}">
        <mvtHeader />
        <section class="inline large">
            <mvtSaleProceeds>
                <template v-slot:intro>
                    <div class="f6 page-title text-bold">HOME SALE PROCEEDS CALCULATOR</div>
                    <h1 class="f0 text-bold">How much can I make selling my home?</h1>
                    <div class="f6">
                        When selling your house, you need to account for certain costs in order to understand your net profit. Our home sale proceeds calculator will help you estimate how much you can walk away with when selling your home.
                    </div>
                </template>
                <template v-slot:sidecard="{ openLead }">
                    <div class="large inline flex vertical bg-default corner outline text-center left">
                        <i class="f1 circle large default disabled icon-investment"></i>
                        <div class="f4 text-bold">What is my home worth?</div>
                        <p>See what your home is worth in today's market and compare it to other nearby homes.</p>
                        <a class="btn primary regular" @click="openLead">Get Free Home Valuation</a>
                    </div>
                </template>
            </mvtSaleProceeds>
        </section>
        <mvtFooter />
    </div>
    <mvtPopSignin />
    <mvtDialogCenter></mvtDialogCenter>
</template>

<script src="./page-homesalecalc.js"></script>